




















import BusinessItem from '@pages/search/components/common/business_item.vue'
import SearchLoadList from '@pages/search/components/mixins/LoadList'
import { Component, Mixins, Prop, Watch, Inject } from 'vue-property-decorator'
import SearchCategory from '@pages/search/components/common/search_category.vue'
import Screen from '@pages/search/components/common/search_screen.vue'
import { List, Toast, Sticky } from 'vant'
import { getSearchResult, RequestType, CategoryList, DistrictBean, CategoryBean } from '@pages/search/search-service'
import { channelIdIsSendForm, creatCollectForm } from './utils'
import { CATEGORY_ID_MAP } from './emun'
import { cookies } from '@utils/index'

@Component({
  components: {
    [List.name]: List,
    [Sticky.name]: Sticky,
    BusinessItem,
    SearchCategory,
    Screen,
  },
})
export default class SearchBusiness extends Mixins(SearchLoadList) {
  @Prop() readonly stickyTop!: number //吸顶的offsettop值 必须要传
  @Prop({ default: 'transparent' }) readonly classifyColor!: string
  @Prop({ default: 90 }) readonly stickyHeight!: number
  @Prop() readonly tabindex!: number
  @Prop() readonly location!: any
  @Prop({ default: '' }) readonly category!: string
  @Prop({ default: '' }) readonly query!: string //产康选择itemtype的值
  @Prop({ default: () => [{ ID: '', NAME: '全城' }] }) readonly districtList!: DistrictBean[]

  @Inject('pageTrackParams')
  pageTrackParams!: any
  @Inject('clickid_tab_business')
  clickid_tab_business!: string

  categoryList: CategoryList[] = [{ title: '全部', list: [{ title: '全部', categoryId: this.category }] }]
  businessCategorySelect: CategoryBean = { title: '全部', categoryId: this.category }
  businessDistrictSelect: DistrictBean = { ID: '', NAME: '全城' }
  businessDistanceSort = true
  businessGoodCommentSort = false

  mounted() {
    this.onLoad()
  }

  //产后恢复专用
  @Watch('query')
  queryChange(val: string) {
    this.refresh()
  }

  //距离排序是否展示
  get locationVis() {
    return this.location && this.location.lat && this.location.lng
  }

  //是否有筛选项
  get ishaveScreen() {
    return this.businessDistanceSort || this.businessGoodCommentSort || this.businessDistrictSelect.ID || this.businessCategorySelect.categoryId != this.category
  }

  get classifyExposure() {
    return `${this.clickid_tab_business}`
  }
  
  changeBusinessCategory(value: any) {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_tab_business, positionParam: { searchtype: '分类' } })
    this.businessCategorySelect = value
    this.refresh()
  }

  changeBusinessDistrict(value: any) {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_tab_business, positionParam: { searchtype: '区域' } })
    this.businessDistrictSelect = value
    this.refresh()
  }

  //排序互斥
  changeBusinessDistanceSort() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_tab_business, positionParam: { searchtype: '距离' } })
    if (this.loading) return
    this.businessDistanceSort = !this.businessDistanceSort
    if (this.businessDistanceSort) {
      this.businessGoodCommentSort = false
    }
    this.refresh()
  }

  changeGoodCommentSort() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_tab_business, positionParam: { searchtype: '好评' } })
    if (this.loading) return
    this.businessGoodCommentSort = !this.businessGoodCommentSort
    if (this.businessGoodCommentSort) {
      this.businessDistanceSort = false
    }
    this.refresh()
  }

  async onLoad() {
    const channelId = +this.$route.params.channelId
    if (this.start === 10 && channelIdIsSendForm(channelId)) {
      // 发送收集表单需求
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const categoryId = CATEGORY_ID_MAP[channelId]
      const data = {
        categoryId: [categoryId],
        utm: 'lb', // 搜索渠道码写死lb
      }
      creatCollectForm(data)
    }
    const { categoryId = '' } = this.businessCategorySelect || {}
    const { ID = '' } = this.businessDistrictSelect || {}
    const result = await getSearchResult({ type: RequestType.RequestBuiness, tabs: '2', query: this.query, start: this.start, openOption: this.categoryList.length === 1, position: this.location, level4CategoryId: categoryId, districtId: ID, distanceSort: this.businessDistanceSort, storeFavPersonNumSort: this.businessGoodCommentSort })
    const { code, data, msg } = result
    if (+code === 1) {
      if (data.categoryInfo && data.categoryInfo.length) {
        this.categoryList = this.getNewCategoryList(data.categoryInfo)
      }
      if (data.businessInfo) {
        const { list: newData = [] } = data.businessInfo
        if (newData.length < 10) {
          this.finished = true
        }
        this.start = this.start + newData.length
        this.list.push(...newData)
      }
    } else {
      this.errormsg = msg || '加载出错，请稍后再试'
      if (this.list.length > 0) {
        this.error = true
        Toast(this.errormsg)
      }
    }
    this.loading = false
  }

  async refresh() {
    this.$emit('totop')
    this.reset()
    this.onLoad()
  }

  resetCondition() {
    this.$emit('totop')
    this.businessCategorySelect = { title: '全部', categoryId: this.category }
    this.businessDistrictSelect = { ID: '', NAME: '全城' }
    this.businessDistanceSort = false
    this.businessGoodCommentSort = false
    this.refresh()
  }

  getNewCategoryList(payload: CategoryList[]) {
    payload.forEach((item: CategoryList) => {
      const num = item.list.length % 4
      const needAddTranslate = num > 1 ? 4 - num : 0 //>1的情况需要加几条空数据 方便ui  justify-content: space-between显示
      for (let index = 0; index < needAddTranslate; index++) {
        item.list.push({})
      }
    })
    return [{ title: '全部', list: [{ title: '全部', categoryId: this.category }] }, ...payload]
  }
}
